import { useStyles } from "./MaderaLoader.styles";

const MaderaLoader = () => {
    const classes = useStyles();
    return (
        <div className={classes.maderaLoaderWrapper}>
            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320.02 320.02">
                <circle
                    className={classes.loaderCircle}
                    cx="160.01"
                    cy="160.01"
                    r="155.04"
                    fill="#EF3340"
                    strokeWidth="0"
                />
                <path
                    className={classes.loaderPath}
                    id="Base"
                    d="M160.01,0C71.63,0,0,71.67,0,160.01s71.63,160.01,160.01,160.01,160.01-71.63,160.01-160.01S248.39,0,160.01,0ZM160.01,21c5.14,0,10.21.27,15.2.85l-.7,10.37-6.03,90.89L123.81,25.8c11.53-3.13,23.67-4.8,36.2-4.8ZM72.52,267.92c-20.81-16.86-36.63-39.61-44.94-65.68l49.97-35.74-5.03,101.41ZM78.75,141.87l-56.04,40.07c-1.12-7.16-1.7-14.47-1.7-21.93,0-48.43,24.91-91.16,62.58-116.03l-4.83,97.89ZM160.01,299.02c-24.99,0-48.46-6.61-68.73-18.22l12.22-247.77c.66-.31,1.31-.58,1.97-.85l115.88,252.57c-18.53,9.13-39.34,14.27-61.34,14.27ZM194.17,28.62l-1.74-3.83c28.74,6.92,54.07,22.78,72.75,44.48l-40.34,26.19-30.67-66.84ZM233,113.21l43.82-28.43c14.04,21.7,22.2,47.54,22.2,75.23,0,2.55-.08,5.11-.23,7.66l-51.64-23.55-14.16-30.9ZM283.63,223.56l-24.14-52.56,36.74,16.75c-2.55,12.65-6.85,24.68-12.61,35.82Z"
                    fill="3fff"
                    strokeWidth="0"
                />
            </svg>
        </div>
    );
};

export default MaderaLoader;
